<template>
    <div>
        <destination-form
            :is-destination-form-sidebar-active.sync="isDestinationFormSidebarActive"
            :destination-data="destinationData"
            @refetch-data="refetchData" 
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12" 
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                                variant="primary"
                                @click="updateDestination()"
                            >
                                <span class="text-nowrap">Add Site Type</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <b-table
                v-if="!destinations.length"
                :items="destinations"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>

            <table class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="col in tableColumns" :key="col.key">
                        {{col.label}}
                    </th>
                    </tr>
                </thead>
                <tr v-for="(item, index) in destinations" :key="index">
                    <td class="pl-2">
                        <div v-html="item.name[currentLocale]"/>
                    </td>
                    <td class="pl-2">
                        <b-badge
                            pill
                            :variant="`light-${resolveStatusVariant(item.is_active)}`"
                            class="text-capitalize"
                        >
                            {{ resolveStatusnameVariant(item.is_active) }} 
                        </b-badge>
                    </td>
                    <td class="pl-2">
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateDestination(item)" variant="outline-success">Edit</b-button>
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                    </td>
                </tr>
            </table>

            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalDestination"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BSidebar,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox
    } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    import store from '@/store'
    import { ref,onUnmounted } from '@vue/composition-api'
    import draggable from 'vuedraggable'
    import { FeatherIcon, MenuIcon } from 'vue-feather-icons'
    import useDestinationList from './useDestinationList'
    import destinationForm from './DestinationForm.vue'
    import sitesStoreModule from '../sitesStoreModule';

    export default {

        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BSidebar,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
            destinationForm, draggable, MenuIcon
        },

        directives:{
            'b-modal': VBModal,
            Ripple
        },

        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
        },

        setup() {
            const SITE_STORE_MODULE_NAME = 'app-sites';
            if (!store.hasModule(SITE_STORE_MODULE_NAME)) store.registerModule(SITE_STORE_MODULE_NAME, sitesStoreModule)
            onUnmounted(() => {
                if (store.hasModule(SITE_STORE_MODULE_NAME)) store.unregisterModule(SITE_STORE_MODULE_NAME)
            });

            const {
                isDestinationFormSidebarActive,
                searchQuery,
                destinationData,
                tableColumns,
                sortBy,
                isSortDirDesc,
                totalDestination,
                perPage,
                currentPage,
                updateServicesOrdering,
                siteTypesForm,
                refetchData,
                fetchData,
                updateDestination,
                deleteData,
                destinations,
                dataMeta,
                refDestinationTable,
                resolveStatusVariant,
                resolveStatusnameVariant,
            } = useDestinationList()

            fetchData();
            
            return {
                isDestinationFormSidebarActive,
                searchQuery,
                destinationData,
                tableColumns,
                sortBy,
                isSortDirDesc,
                totalDestination,
                perPage,
                currentPage,
                updateServicesOrdering,
                siteTypesForm,
                refetchData,
                fetchData,
                updateDestination,
                deleteData,
                destinations,
                dataMeta,
                refDestinationTable,
                resolveStatusVariant,
                resolveStatusnameVariant,
            }
        },

        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm(`Please confirm that you want to delete site type ID: ${id}`, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                            this.deleteData(id)
                        }
                    }
                )
            },
        }
    }
</script>